// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Home_wrapper__cyGMo","bigButton":"Home_bigButton__82krR","input":"Home_input__1o7gA"};